// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__12_LA","insightsList":"newBusinessInsightsMenu_insightsList__29GQt","active":"newBusinessInsightsMenu_active__2sKfY"};